import { Document, Font, StyleSheet } from "@react-pdf/renderer";

import NunitoBold from "assets/fonts/Nunito-Bold.ttf";
import NunitoMedium from "assets/fonts/Nunito-Medium.ttf";
import NunitoRegular from "assets/fonts/Nunito-Regular.ttf";
import NunitoSemiBold from "assets/fonts/Nunito-SemiBold.ttf";
import logo from "assets/images/logo.png";
import InvoicePage from "./InvoicePage";
import WoCuttingPdfProducts from "./WoCuttingPdfProducts";

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#fff",
    paddingVertical: 10,
    paddingHorizontal: 20,
    fontFamily: "Nunito",
    fontSize: 10,
  },
  topHeader: {
    height: 75,
  },
  shippingDescription: {
    marginVertical: 0,
  },
  headingMain: { fontSize: 20, fontWeight: "600" },
  headingSecond: { fontSize: 12, fontWeight: "600" },
  headingThird: { fontSize: 15, fontWeight: "600" },
  textbody: { fontSize: 10 },
  mainContainer: {
    marginBottom: "5px",
    flexDirection: "column",
    border: "1px solid grey",
  },
  prodTitle: {
    width: "100%",
    textAlign: "left",
    padding: "5px 10px",

    borderBottom: "1px solid grey",
    fontSize: "14px",
  },
  prodMain: {
    width: "100%",
    flexDirection: "row",
  },
  prodContent: {
    flexGrow: 1,
  },
  prodSizes: {
    padding: "5px",
    width: "150px",
    borderLeft: "1px solid grey",
  },
  prodInfoRow: {
    display: "flex",
    flexDirection: "row",
    fontSize: "10px",
  },
  prodCol: {
    display: "flex",
    flexDirection: "row",
    width: "50%",
  },
  prodKey: {
    padding: "3px 5px",
    width: "40%",
    borderRight: "1px solid grey",
    borderBottom: "1px solid grey",
  },
  prodVal: {
    padding: "3px 5px",
    width: "60%",
    borderBottom: "1px solid grey",
  },
  prodComments: {
    padding: "5px 10px",
    fontSize: "12px",
    borderTop: "1px solid grey",
  },
  prodSubHeading: {
    fontSize: "12px",
  },
  prodTxt: {
    fontSize: "10px",
  },
  borderRight: { borderRight: "1px solid grey" },
  colWithLong: {
    width: "200px",
    marginTop: 5,
    marginBottom: 3,
  },
  colWith: {
    width: "60px",
    marginTop: 5,
    marginBottom: 3,
    marginHorizontal: 5,
  },
  colWithMd: {
    width: "40px",
    marginTop: 5,
    marginBottom: 3,
  },
  colWithSm: {
    width: "30px",
    marginTop: 5,
    marginBottom: 3,
  },
  colWithXs: {
    width: "10px",
    marginTop: 5,
    marginBottom: 3,
  },
});

Font.register({
  family: "Nunito",
  fonts: [
    { src: NunitoRegular },
    { src: NunitoSemiBold, fontWeight: "600" },
    { src: NunitoBold, fontWeight: "bold" },
    { src: NunitoMedium, fontWeight: "medium" },
  ],
});

// Create Document Component
export const WoCuttingPdf = ({
  selectedWO,
  showInvoicePage,
  productsList,
  locationLogo,
  showContactShipping = true,
}) => {
  /*   ALL STATES
   ********************************************* */

  /*   ALL FUnctions
   ********************************************* */

  /*   All Use Effects
   ********************************************* */

  return (
    <>
      <Document
        title={`W-${selectedWO?.woId?.toString()}`}
        author="OrderRun-Work Order"
      >
        {showInvoicePage && (
          <InvoicePage
            selectedWO={selectedWO}
            styles={styles}
            productsList={selectedWO?.WOProducts}
            locationLogo={locationLogo}
          />
        )}

        {productsList && productsList.length > 0 && (
          <WoCuttingPdfProducts
            styles={styles}
            selectedWO={selectedWO}
            logo={logo}
            locationLogo={locationLogo}
            productsList={productsList}
            showContactShipping={showContactShipping}
          />
        )}
      </Document>
    </>
  );
};
